Selector.View.QuestionListView = Backbone.View.extend(
/** @lends Selector.View.QuestionListView# */
{
	initialize: function() {

    	_.bindAll(this, "render");
        this.collection.on('reset',this.render);
        this.collection.on('change',this.render);
        
	},

    events: {
        "click .e_selector_button_group_next": 	"submitManyAnswer"
    },

    modelViews: [],

    /** Render function */
	render: function() {

	    var _this = this;

        this.modelViews = [];

        //allows app to be loaded on page without the DOM element being present
        this.setElement($(".e_selector_questions"));

        var fragment = document.createDocumentFragment(),
            count = 0;

        if (this.collection.groups) {
            this.$el.show();

            this.collection.each(function (model) {
                if (model.get("GROUP") == _this.collection.groupActive) {
                    model.set("COUNT", ++count);
                    var modelView = new Selector.View.QuestionView({model: model});
                    fragment.appendChild(modelView.render().el);
                    _this.modelViews.push(modelView);
                }
            }, this);
            //buttons
            if (count > 0) {
                var groupButtonsTemplate = _.template($('#selector_group_buttons').html());
                fragment.appendChild(document.createRange().createContextualFragment(groupButtonsTemplate({groups: ele.selector.data.GROUPS, groupActive: this.collection.groupActive})));
            } else {
                this.$el.hide();
            }

        } else {
            this.collection.each(function (model) {
                if (model.get("ACTIVE")) {
                    model.set("COUNT", ++count);
                    var modelView = new Selector.View.QuestionView({model: model});
                    fragment.appendChild(modelView.render().el);
                    _this.modelViews.push(modelView);
                }
            }, this);
        }

		this.$el.html(fragment);

        if (ele.uri.getParameterByName(window.location.href, "sendEvents")) {
            window.parent.document.dispatchEvent(new CustomEvent('resizeIframe'));
        }
 
        const selectorQuestion = document.querySelector('.e_selector_questions');
        if (selectorQuestion.children.length === 0) {
            selectorQuestion.style.display = 'none';
        } else {
            selectorQuestion.style.display = 'block';
        }

		return this;
	},

    submitManyAnswer: function(e) {

	    _.each(this.modelViews, function(v) {
	        v.getAnswerFromForm();
        });

        this.collection.save = true;
        this.collection.parseAnswers();
        this.render();

    }

});